import React from 'react'
import { LeftSide } from '../style'
import { CertificateType } from '..'
import SelectParamInCertificate from '../../../../../components/Certificates/SelectItem/Param'
import SelectSupplierInCertificate from '../../../../../components/Certificates/SelectItem/Supplier'
import SelectCustomerInCertificate from '../../../../../components/Certificates/SelectItem/Customer'
import SelectHeatNumberInCertificate from '../../../../../components/Certificates/SelectItem/HeatNumber'
import SelectCertificateTypeInCertificate from '../../../../../components/Certificates/SelectItem/CertificateType'
import { Label, InputDiv, Input } from '../../../../../components/styles/select-style'
import SelectMaterialInCertificate from '../../../../../components/Certificates/SelectItem/Material'

interface PropsType {
  certificate: CertificateType
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>
}

const CertificateFields:React.FC<PropsType> = ({certificate, setCertificate}) => {
  return (
    <LeftSide>
      <SelectSupplierInCertificate certificate={certificate} setCertificate={setCertificate} />
      <SelectCustomerInCertificate certificate={certificate} setCertificate={setCertificate} />
      {/* <SelectCertificateTypeInCertificate certificate={certificate} setCertificate={setCertificate} /> */}
      <SelectParamInCertificate certificate={certificate} setCertificate={setCertificate} />
      <SelectHeatNumberInCertificate certificate={certificate} setCertificate={setCertificate} />
      <SelectMaterialInCertificate certificate={certificate} setCertificate={setCertificate} />
      <InputDiv>
        <Label>Descrição</Label>
        <Input 
          placeholder='Digite aqui'
          value={certificate.description || ''}
          onChange={(e) => setCertificate(prev => ({...prev, description:e.target.value}))}
        />
      </InputDiv>
      <InputDiv>
        <Label>Usina de fabricação</Label>
        <Input 
          placeholder='Digite aqui'
          value={certificate.factory || ''}
          onChange={(e) => setCertificate(prev => ({...prev, factory:e.target.value}))}
        />
      </InputDiv>
      <InputDiv>
        <Label>Nota fiscal</Label>
        <Input 
          placeholder='Digite aqui'
          value={certificate.invoiceNumber || ''}
          onChange={(e) => setCertificate(prev => ({...prev, invoiceNumber:e.target.value}))}
        />
      </InputDiv>
      <InputDiv>
        <Label>Norma</Label>
        <Input 
          placeholder='Digite aqui'
          value={certificate.standard || ''}
          onChange={(e) => setCertificate(prev => ({...prev, standard:e.target.value}))}
        />
      </InputDiv>
      <InputDiv>
        <Label>Tratamento térmico</Label>
        <Input 
          placeholder='Digite aqui'
          value={certificate.heatTreatment || ''}
          onChange={(e) => setCertificate(prev => ({...prev, heatTreatment:e.target.value}))}
        />
      </InputDiv>
      <InputDiv>
        <Label>Nº do pedido de compra</Label>
        <Input 
          placeholder='Digite aqui'
          value={certificate.purchaseOrderNumber || ''}
          onChange={(e) => setCertificate(prev => ({...prev, purchaseOrderNumber:e.target.value}))}
        />
      </InputDiv>
      <InputDiv>
        <Label>Observações</Label>
        <Input 
          placeholder='Digite aqui'
          value={certificate.observations || ''}
          onChange={(e) => setCertificate(prev => ({...prev, observations:e.target.value}))}
        />
      </InputDiv>
    </LeftSide>
  )
}

export default CertificateFields